import { ThemeOptions } from "@mui/material";
import {
  commonBorderRadius,
  generateErrorWarnInfoColors,
  MuiButton,
  MuiChip,
  MuiFilledInput,
  styleRootCommonAppBar
} from "./util/theme-generator-util";

export const zipperFontFamilyTitle = "Zipper";
export const zipperFontFamilyRegular = "Rubik";

export const zipperThemeConfig: ThemeOptions = {
  components: {
    MuiChip,
    MuiButton,
    MuiFilledInput,
    MuiAppBar: {
      styleOverrides: {
        root: styleRootCommonAppBar
      }
    }
  },
  shape: {
    borderRadius: commonBorderRadius
  },
  palette: {
    primary: {
      main: "#DC4914"
    },
    secondary: {
      main: "#444D4A"
    },
    ...generateErrorWarnInfoColors(),
    background: {
      default: "#F5F3ED",
      paper: "#FFFFFF"
    },
    text: {
      primary: "#000000",
      secondary: "#444D4A"
    },
    action: {
      disabledOpacity: 0
    }
  },

  typography: {
    fontFamily: zipperFontFamilyRegular,
    h1: {
      fontStyle: "normal",
      fontWeight: "700",
      fontFamily: zipperFontFamilyTitle,
      fontSize: "32px",
      lineHeight: "38px",
      letterSpacing: "normal",
      textTransform: "uppercase"
    },
    h2: {
      fontStyle: "normal",
      fontWeight: "700",
      fontFamily: zipperFontFamilyTitle,
      fontSize: "24px",
      lineHeight: "28px",
      letterSpacing: "normal",
      textTransform: "uppercase"
    },
    h3: {
      fontStyle: "normal",
      fontWeight: "700",
      fontFamily: zipperFontFamilyRegular,
      fontSize: "20px",
      lineHeight: "24px",
      letterSpacing: "normal"
    },
    h4: {
      fontStyle: "normal",
      fontWeight: "700",
      fontFamily: zipperFontFamilyRegular,
      fontSize: "16px",
      lineHeight: "20px",
      letterSpacing: "normal"
    },
    subtitle1: {
      fontStyle: "normal",
      fontWeight: "400",
      fontFamily: zipperFontFamilyRegular,
      fontSize: "24px",
      lineHeight: "28px",
      letterSpacing: "normal"
    },
    body1: {
      fontFamily: zipperFontFamilyRegular,
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "20px"
    },
    body2: {
      fontFamily: zipperFontFamilyRegular,
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "14px"
    },
    caption: {
      fontFamily: zipperFontFamilyRegular,
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "16px"
    }
  }
};
